import {
  FieldTemplateProps,
  getTemplate,
  getUiOptions,
  RJSFSchema,
  StrictRJSFSchema,
} from '@rjsf/utils';

import { REQUIRED_FIELD_SYMBOL } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/constants';
import FormControl, { Label } from 'design-system/components/FormControl';

/** The `FieldTemplate` component is the template used by `SchemaField` to render any field. It renders the field
 * content, (label, description, children, errors and help) inside of a `WrapIfAdditional` component.
 *
 * @param props - The `FieldTemplateProps` for this component
 */
export function FieldTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>(
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  props: FieldTemplateProps<T, S, F>,
) {
  const {
    id,
    label,
    children,
    errors,
    help,
    description,
    hidden,
    required,
    displayLabel,
    registry,
    uiSchema,
    rawErrors,
    disabled,
    schema,
  } = props;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const uiOptions = getUiOptions(uiSchema);
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const WrapIfAdditionalTemplate = getTemplate<'WrapIfAdditionalTemplate', T, S, F>(
    'WrapIfAdditionalTemplate',
    registry,
    uiOptions,
  );

  if (hidden) {
    return <div className='hidden'>{children}</div>;
  }

  // we don't want to nest objects in more FormControls
  if (schema.type === 'object') {
    return <>{children}</>;
  }

  return (
    <WrapIfAdditionalTemplate {...props}>
      {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
      <FormControl inputId={id} disabled={disabled} hasError={rawErrors?.length > 0}>
        {displayLabel && (
          <Label>
            {label}
            {required ? REQUIRED_FIELD_SYMBOL : null}
          </Label>
        )}
        {/* Skip description for array fields as children component will render description field */}
        {schema.type !== 'array' && description ? description : null}
        {children}
        {errors}
        {help}
      </FormControl>
    </WrapIfAdditionalTemplate>
  );
}
